import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../../pageheader/PageHeader";
import NavPatient from "../../patients/navPatien/NavPatient";
import styles from "./TablePermissionAccessPatient.module.css";
import { TrashIcon } from "@heroicons/react/24/outline";
import * as patientApi from "../../../service/patientApiDev";
import * as userApi from "../../../service/userApi";
import moment from "moment/moment";
import "moment/locale/th";
import Pagination from "../../pagination/Pagination";
import { HashLoader } from "react-spinners";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Option, Select } from "@material-tailwind/react";
import Checkbox from "../../material/checkbox/Checkbox";
import { RedirectCode400 } from "../../RedirectCode400";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../material/button/Button";
import { CurrentUserContext } from "../../../App";

import design from "../../doctor/ListDataPatient.module.css";
import ModalRigthToAccessData from "../../material/modal/ModalRigthToAccessData";
import ModalCancelAccessToData from "../../material/modal/ModalCancelAccessToData";

import Breadcrumb from "../breacrumb/breadcrumb";

import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClock,
  faEdit,
  faFileLines,
  faGenderless,
  faHospital,
  faMinusCircle,
  faTrash,
  faUserDoctor,
} from "@fortawesome/free-solid-svg-icons";
import HeadBar from "../headBar/HeadBar";
import ModalRigthToAccessDataV2 from "../../material/modal/ModalRigthToAccessDataV2";
import ModalCancelAccessToDataV2 from "../../material/modal/ModalCancelAccessToDataV2";
import ModalShowAccessData from "../../material/modal/ModalShowAccessData";
import Footer from "../footer/Footer";
import PaginationV2 from "../../paginationV2/PaginationV2";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

const customStyles_new = {
  rows: {
    style: {
      // override the row height
      // '&:nth-child(even)': {
      //     background: '#effff4'
      // },
      // '&:not(:last-of-type)': {
      //     borderBottomWidth: 'none'
      // }
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      // display: 'flex',
      // justifyContent: 'center',
      // background: '#B8DFC7',
      fontSize: 16,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      // display: 'flex',
      // justifyContent: 'center',
      borber: "1px solid #B8DFC7",
    },
  },
};

let day = new Date().toLocaleDateString("th-TH", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

function PermissionAccessPatient() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const location = useLocation();

  const navigate = useNavigate();

  const [toggle, setToggle] = useState(
    location.state?.type ? location.state.type : "listDoctors",
  );

  const [everyTime, setEveryTime] = useState(false);
  const [someTime, setSomeTime] = useState(false);
  const [selectCheckSeeData, setSelectCheckSeeData] = useState([
    {
      id: "ALL",
      name: "สถานะทั้งหมด",
    },
    {
      id: "ACCEPT",
      name: "อนุญาตแล้ว",
    },
    {
      id: "PENDING",
      name: "ยังไม่ได้รับอนุญาต",
    },
    {
      id: "REJECT",
      name: "ปฏิเสธการเข้าถึงข้อมูล",
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [valueSearch, setValueSearch] = useState("");
  const [selectstatus, setSelectstatus] = useState("ALL");

  const [permission_list, setPermission_list] = useState([]);

  const [totalMedical, setTotalMedical] = useState(0);
  const [permission_list_storage, setPermission_list_storage] = useState([]);

  const [permissionList, setPermissionList] = useState([]);

  const [openModalAccess, setOpenModalAccess] = useState(false);
  const [permissionData, setPermissionData] = useState([]);

  const [openModalCancel, setOpenModalCancel] = useState(false);
  const [permissionCancel, setPermissionCancel] = useState([]);

  const [openModalShowData, setOpenModalShowData] = useState(false);
  const [permissionDataShow, setPermissionDataShow] = useState([]);

  useEffect(() => {
    getRequestPermission();
  }, [page, selectstatus, toggle]);

  useEffect(() => {
    getActivePermissionPatient();
  }, [toggle]);

  //ใช้ default page ให้มาเริ่มต้นหลังเลือก option ใหม่
  useEffect(() => {
    setPage(1);
  }, [selectstatus]);

  // useEffect(() => {
  //   if (valueSearch !== "") {
  //     setPermission_list(
  //       permission_list_storage.filter((element, idx) => {
  //         return (
  //           element["doctor"]["fname"] + element["doctor"]["lname"]
  //         ).includes(valueSearch);
  //       }),
  //     );
  //   } else {
  //     setPermission_list(permission_list_storage);
  //   }
  // }, [valueSearch]);

  useEffect(() => {
  if (valueSearch !== "") {
    const filtered = permission_list_storage.filter((element) => {
      const fname = element?.doctor?.fname || "";
      const lname = element?.doctor?.lname || "";
      const fullName = `${fname}${lname}`; 
      return fullName.toLowerCase().includes(valueSearch.toLowerCase());
    });
    
    setPermission_list(filtered);
  } else {
    setPermission_list(permission_list_storage);
  }
}, [valueSearch, permission_list_storage]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getUserData();
  }, []);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await patientApi.getRequestPermission(selectstatus, page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setPermission_list(res["data"]["permission_list"]);
        setPermission_list_storage(res["data"]["permission_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalMedical(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const acceptCredentialToken = async (
    permission_id,
    accept,
    everyTime,
    someTime,
  ) => {
    setLoading(true);
    let res = await patientApi.acceptCredentialToken(
      permission_id,
      accept,
      everyTime,
      someTime,
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        setOpenModalAccess(false);
        setOpenModalCancel(false);
        getRequestPermission();
        getActivePermissionPatient();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getUserData = async () => {
    setLoading(true);
    let res = await userApi.data();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setEveryTime(
          res["data"]["user_data"]["permission"]["access_data_every_time"],
        );
        setSomeTime(
          res["data"]["user_data"]["permission"]["access_data_some_time"],
        );
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getActivePermissionPatient = async () => {
    setLoading(true);
    let res = await patientApi.getActivePermissionPatient();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setPermissionList(res["data"]["permission_list"]);
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "error", data: res["data"]["message_th"] });
    }
  };

  const remainingTime = (timeStamp) => {
    const dateNow = new Date();
    const date = new Date(timeStamp);
    const diffTime = Math.abs(date - dateNow);

    const hours = Math.floor(diffTime / (1000 * 60 * 60));
    const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    if (hours > 24) {
      return "หมดเวลา";
    } else {
      return hours + " ชั่วโมง " + minutes + " นาที";
    }
  };

  const acceptCredential = (i) => {
    setPermissionData(i);
    setOpenModalAccess(true);
  };

  const clickCancelRights = (item) => {
    setPermissionCancel(item);
    setOpenModalCancel(true);
  };

  const clickShowData = (i) => {
    setPermissionDataShow(i);
    setOpenModalShowData(true);
  };

  const columnsListDoctors = [
    {
      name: "ลำดับ",
      selector: (item, index) => (
        <div className="text-center w-[30px]">
          {index + 1 + (page - 1) * 10}
        </div>
      ),
      wrap: true,
      width: "80px",
    },
    {
      name: "ชื่อ",
      selector: (item) => <div>{item["doctor"]["fname"]}</div>,
      wrap: true,
    },
    {
      name: "นามสกุล",
      selector: (item) => <div>{item["doctor"]["lname"]}</div>,
      wrap: true,
    },
    {
      name: "สังกัด",
      selector: (item) => (
        <div className="flex flex-row gap-1">
          <div>
            <FontAwesomeIcon icon={faHospital} />
          </div>
          {item["doctor"]?.["hospital"]?.["hospital_name"] ?? 'ไม่พบข้อมูลสังกัด'}
        </div>
      ),
      wrap: true,
      width: "210px",
    },
    {
      name: "ตำแหน่ง",
      selector: (item) => (
        <div className="flex flex-row">
          <FontAwesomeIcon
            icon={faUserDoctor}
            className="text-pink-700 pr-2 pt-2"
          />{" "}
          -{" "}
        </div>
      ),
      wrap: true,
    },
    {
      name: "สถานะ",
      selector: (item) => (
        <div>
          {item["status"] === "PENDING" ? (
            <div>
              <FontAwesomeIcon icon={faGenderless} /> รออนุมัติ
            </div>
          ) : item["status"] === "ACCEPT" ? (
            <div className="text-light-green-600">
              <FontAwesomeIcon icon={faCheck} /> อนุญาตแล้ว
            </div>
          ) : item["status"] === "REJECT" ? (
            <div className="text-red-700">
              <FontAwesomeIcon icon={faMinusCircle} /> ปฏิเสธ
            </div>
          ) : (
            "พบสถานะอื่น"
          )}
        </div>
      ),
      width: "120px",
    },
    {
      name: "ระยะเวลาเข้าถึง",
      selector: (item) => (
        <div>
          {
          // item["status"] === "ACCEPT" &&
          item["access_data_every_time"] == true ? (
            <div> ไม่จำกัดเวลา </div>
          ) : 
          // item["status"] === "ACCEPT" ? (
          //   <div className="text-amber-900">
          //     <FontAwesomeIcon icon={faClock} />{" "}
          //     {remainingTime(item["credential_token_expire"])}
          //   </div>
          // ) : (
          //   <div> - </div>
          // )
          <div>{item["credential_token_expire"] ? remainingTime(item["credential_token_expire"]) : 'ภายใน  24 ชั่วโมง'}</div>
          }
        </div>
      ),
      wrap: true,
    },
    {
      name: "ดูเพิ่มเติม/จัดการ",
      selector: (item) => (
        <div className="xl:gap-2 flex flex-row gap-5 w-full text-lg">
          <div
            onClick={() => {
              clickShowData(item);
            }}
            className="text-cyan-700 cursor-pointer"
          >
            <FontAwesomeIcon icon={faFileLines} />
          </div>
          <div
            onClick={() => {
              acceptCredential(item);
            }}
            className="cursor-pointer"
          >
            <FontAwesomeIcon icon={faEdit} />
          </div>
          <div
            onClick={() => {
              clickCancelRights(item);
            }}
            className="text-red-700 cursor-pointer"
          >
            <FontAwesomeIcon icon={faTrash} />
          </div>
        </div>
      ),
    },
  ];

  const columnsAccessHistory = [
    {
      name: "ลำดับ",
      selector: (item, index) => (
        <div className="text-center w-[30px]">
          {index + 1 + (page - 1) * 10}
        </div>
      ),
      wrap: true,
      width: "80px",
    },
    {
      name: "ชื่อหมอ",
      selector: (item) => <div>{item["doctor"]["fname"]}</div>,
      wrap: true,
    },
    {
      name: "นามสกุล",
      selector: (item) => <div>{item["doctor"]["lname"]}</div>,
      wrap: true,
    },
    {
      name: "สังกัด",
      selector: (item) => 
      (
        <div className="flex flex-row">
          <FontAwesomeIcon icon={faHospital} className="pr-2 pt-2" />
          {item["doctor"]?.["hospital"]?.["hospital_name"] ?? 'ไม่พบข้อมูลสังกัด'}
        </div>
      ),
      wrap: true,
      width: "210px",
    },
    {
      name: "ตำแหน่ง",
      selector: (item) => (
        <div className="flex flex-row">
          <FontAwesomeIcon
            icon={faUserDoctor}
            className="text-pink-700 pr-2 pt-2"
          />
        </div>
      ),
      wrap: true,
    },
    {
      name: "สถานะ",
      selector: (item) => (
        <div>
          {item["status"] === "PENDING" ? (
            <div
              onClick={() => {
                acceptCredential(item);
              }}
              className="flex flex-row justify-between w-[100px]"
            >
              <div className="cursor-pointer">
                <FontAwesomeIcon icon={faGenderless} /> รออนุญาต
              </div>
            </div>
          ) : item["status"] === "ACCEPT" ? (
            <div className="flex flex-row justify-between w-[100px]">
              <div className="flex text-light-green-600">
                <FontAwesomeIcon icon={faCheck} /> อนุญาตแล้ว
              </div>
              {/* <FontAwesomeIcon icon={faEdit}/> */}
            </div>
          ) : item["status"] === "REJECT" ? (
            <div
              onClick={() => {
                acceptCredential(item);
              }}
              className="flex flex-row justify-between w-[100px]"
            >
              <div className="flex text-red-700 cursor-pointer">
                <FontAwesomeIcon icon={faMinusCircle} /> ปฏิเสธ
              </div>
            </div>
          ) : (
            "พบสถานะอื่น"
          )}
        </div>
      ),
    },
    {
      name: "",
      selector: (item) => (
        <div className="w-[100px]">
          {item["status"] === "PENDING" ? (
            <div
              onClick={() => {
                acceptCredential(item);
              }}
              className="w-[80px] px-3 py-2 text-blue-500 border-blue-500 border cursor-pointer text-center rounded-md"
            >
              ยินยอม
            </div>
          ) : item["status"] === "ACCEPT" ? (
            <div className="flex flex-row justify-between w-[80px]">
              {/* <div className='flex text-light-green-600'>
                                <FontAwesomeIcon icon={faCheck}/> อนุญาตแล้ว
                            </div> */}
              {/* <FontAwesomeIcon icon={faEdit}/> */}
            </div>
          ) : item["status"] === "REJECT" ? (
            <div
              onClick={() => {
                acceptCredential(item);
              }}
              className="w-[80px] px-1 py-2 border-black border cursor-pointer text-center rounded-md"
            >
              แก้ไขสถานะ
            </div>
          ) : (
            "พบสถานะอื่น"
          )}
        </div>
      ),
    },
    {
      name: "ระยะเวลาเข้าถึง",
      selector: (item) => (
        <div>
          {
          // item["status"] === "ACCEPT" &&
          item["access_data_every_time"] == true ? (
            <div> ไม่จำกัดเวลา </div>
          ) : 
          // item["status"] === "ACCEPT" ? (
          //   <div className="text-amber-900">
          //     <FontAwesomeIcon icon={faClock} />{" "}
          //     {remainingTime(item["credential_token_expire"])}
          //   </div>
          // ) : (
          //   <div> - </div>
          // )
          <div>{item["credential_token_expire"] ? remainingTime(item["credential_token_expire"]) : 'ภายใน  24 ชั่วโมง'}</div>
          }
        </div>
      ),
      wrap: true,
      width: "150px",
    },
  ];
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "กำหนดสิทธิการเข้าถึงข้อมูล", url: "/" },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />

        <PageHeader
          titlename={"กำหนดสิทธิการเข้าถึงข้อมูล"}
          description={
            "จัดการรายชื่อแพทย์ที่สามารถเข้าถึงข้อมูลการตรวจแลปของคุณ"
          }
        />
        <div className="mt-[5%]">
          <div className="md:text-sm md:gap-4 flex flex-row gap-8 w-full text-lg border-b-2 border-gray-200">
            <button
              className={`flex items-center py-2 text-nowrap border-b-4 ${toggle === "listDoctors" ? "text-[#42A1EF] border-b-4 border-[#42A1EF]" : "border-white"}`}
              onClick={() => {
                setToggle("listDoctors");
              }}
            >
              รายชื่อแพทย์ที่มีสิทธิเข้าถึงข้อมูล
            </button>
            <button
              className={`flex items-center py-2 text-nowrap border-b-4 ${toggle === "accessHistory" ? "text-[#42A1EF] border-b-4 border-[#42A1EF]" : "border-white"}`}
              onClick={() => {
                setToggle("accessHistory");
              }}
            >
              ประวัติการขออนุญาตจากแพทย์
            </button>
          </div>

          {toggle === "listDoctors" ? (
            <div>
              <div className="mt-8 md:mt-4 ">
                <div>
                  <p className="md:text-sm text-lg">
                    รายชื่อแพทย์ที่อนุญาตให้เข้าถึงข้อมูล
                  </p>
                  <p className="text-xs text-gray-700">
                    <FontAwesomeIcon icon={faClock} /> ข้อมูลประจำวันที่ {day}
                  </p>
                  <p className="mt-2 mb-2 text-[#000000] text-base md:text-sm">
                    จำนวน {permissionList.length} รายการ
                  </p>
                </div>
              </div>

              {loading ? (
                <div className="flex justify-center items-center mt-[10px]">
                  <HashLoader color="#FF9768" size={70} />
                  <div
                    style={{
                      marginTop: "20px",
                      color: "#FF9768",
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    loading...
                  </div>
                </div>
              ) : (
                <div className={styles.align}>
                  <DataTable
                    className="border-y border-gray-400"
                    columns={columnsListDoctors}
                    data={permissionList}
                    customStyles={customStyles_new}
                    noDataComponent={
                      <div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>
                    }
                  />
                </div>
              )}
            </div>
          ) : null}

          {toggle === "accessHistory" ? (
            <div>
              <div className="mt-8 md:mt-4">
                <div>
                  <p className="md:text-sm text-lg">
                    ประวัติการเข้าถึงข้อมูลจากแพทย์
                  </p>
                  <p className="text-xs text-gray-700">
                    <FontAwesomeIcon icon={faClock} /> ข้อมูลประจำวันที่ {day}
                  </p>
                  <p className="mt-2 mb-2 text-[#000000] text-base md:text-sm">
                    จำนวน {totalMedical} รายการ
                  </p>
                </div>
              </div>

              <div>
                <div className="mb-4">
                  <div className="flex sm:grid sm:grid-cols-1 gap-4">
                    <div className="w-1/3 md:w-full">
                      <Select
                        label="เลือกสถานะการเข้าถึงข้อมูล"
                        color={"orange"}
                        value={selectstatus}
                        onChange={setSelectstatus}
                      >
                        {selectCheckSeeData.map((i, idx) => {
                          return (
                            <Option key={idx} value={i["id"]}>
                              {i["name"]}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>

                    <div className="w-1/3 md:w-full">
                      <input
                        disabledLabel
                        className="w-full border-2 border-solid border-[#A2B5BC] rounded-lg text-state-100 text-[#000000] px-4 py-2"
                        // onChange={handleChangeInputSearch}
                        placeholder="ค้นหาข้อมูลด้วยชื่อ"
                        value={valueSearch}
                        onChange={(e) => {
                          setValueSearch(e.target.value);
                        }}
                      ></input>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="flex justify-center items-center mt-[10px]">
                    <HashLoader color="#FF9768" size={70} />
                    <div
                      style={{
                        marginTop: "20px",
                        color: "#FF9768",
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      loading...
                    </div>
                  </div>
                ) : (
                  <>
                    <div className={styles.align}>
                      <DataTable
                        className="border-y border-gray-400"
                        columns={columnsAccessHistory}
                        data={permission_list}
                        customStyles={customStyles_new}
                        noDataComponent={
                          <div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>
                        }
                      />
                    </div>
                    <PaginationV2
                      page={page}
                      totalPage={maxPage}
                      clickForward={() => {
                        if (page < maxPage) {
                          setPage(page + 1);
                        }
                      }}
                      clickBackward={() => {
                        if (page > 1) {
                          setPage(page - 1);
                        }
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          ) : null}
        </div>

        {openModalShowData ? (
          <ModalShowAccessData
            onClose={() => {
              setOpenModalShowData(false);
            }}
            data={permissionDataShow}
          />
        ) : null}

        {openModalAccess ? (
          <ModalRigthToAccessDataV2
            onClose={() => {
              setOpenModalAccess(false);
            }}
            data={permissionData}
            onClickData={(id, accept, every, some) => {
              // console.log('modalAccess', id, accept, every, some)
              acceptCredentialToken(id, accept, every, some);
            }}
          />
        ) : null}

        {openModalCancel ? (
          <ModalCancelAccessToDataV2
            onClose={() => {
              setOpenModalCancel(false);
            }}
            data={permissionCancel}
            onClickData={(id, accept, every, some) => {
              // console.log('modalCancel', id, accept, every, some)
              acceptCredentialToken(id, accept, every, some);
            }}
          />
        ) : null}
      </div>
    </>
  );
}

export default PermissionAccessPatient;
